import { AxiosResponse } from "axios";
import { format } from "date-fns";
import InputElement from "../../models/common/InputElement";
import EventCLusterDTO from "../../models/EventClusterDTO";
import EventDTO from "../../models/EventDTO";
import EventTypeDTO from "../../models/EventTypeDTO";

import apiRequest from "../../utils/apiUtils/apiRequest";
import courseApiRequest from "../../utils/apiUtils/courseApiRequest";


export function submitFormWithFile(formValues: Array<InputElement>, formName: string) {
    let file = formValues.filter(v => v.type === "file").map(v => v.value)[0]!; // ! tells typescript that this value will never be undefined
    var formData = new FormData();

    formData.append("file", file);
    const formJson = JSON.stringify(formValues.filter(v => v.type !== "file"));
    const form = new Blob([formJson], { type: 'application/json' });

    formData.append("form", form);
    const url = "/form/send/" + formName;
    return apiRequest.post(url, formData).then((response: AxiosResponse) => {
        return response;
    });
}

export function submitForm(formValues: Array<InputElement>, formName: string) {
    // let file = formValues.filter(v => v.type === "file").map(v => v.value)[0]!; // ! tells typescript that this value will never be undefined
    var formData = new FormData();

    // formData.append("file", file);
    console.log(formValues);
    const formJson = JSON.stringify(formValues);
    const form = new Blob([formJson], { type: 'application/json' });

    formData.append("form", form);
    const url = "/form/send/" + formName;
    return apiRequest.post(url, formData).then((response: AxiosResponse) => {
        return response;
    });
}

export function addEditEvent(formValues: Array<InputElement>, formName: string, clusterId?: number) {

    const event = createEventClass(formValues, clusterId);
    console.log(event);

    const url = "/events/addOrEdit";
    return courseApiRequest.post(url, event).then((response: AxiosResponse) => {
        // return <Redirect to="/not-found" />;
        // props.history.push('/path')
    });
}

function createEventClass(formValues: Array<InputElement>, clusterId?: number): EventCLusterDTO {
    let eventDTO = new EventDTO();
    let eventTypeDTO = new EventTypeDTO();
    // let date = "";
    let time = "";
    let description = "";
    // if (eventId) {
    //     eventDTO.id = eventId;
    // }

    for (let element of formValues) {
        switch (element.name) {
            case "Email":
                eventDTO.createdBy = element.value;
                break;
            // case "Date":
            //     date = element.value || "";
            //     break;
            case "Time 1":
                time = element.value || "";
                break;
            case "Timezone":
                eventDTO.timezone = element.value;
                break;
            case "Event link":
                eventDTO.link = element.value;
                break;
            case "Description":
                eventDTO.description = element.value + " | ";
                break;
            case "Language":
                eventDTO.eventLanguage = element.value?.toUpperCase();
                break;
            case "Region":
                eventTypeDTO.region = element.value;
                break;
            case "Type":
                eventTypeDTO.name = element.value;
                break;
            case "Agenda":
                eventDTO.agenda = element.value;
                break;
            case "Extra info":
                eventDTO.extraInfo = element.value;
                break;

        }
    }
    eventDTO.type = eventTypeDTO;


    let allEventsDays = formValues.filter(e => e.name.includes("Day")).map(e => e.value);
    let allEventsTime = formValues.filter(e => e.name.includes("Time ")).map(e => e.value);
    const descriptionFirstPart = (eventTypeDTO.name === "WEBINAR" || eventTypeDTO.name === "HOT") ? eventDTO.description : handleDescriptionText(eventTypeDTO.name || " ", eventDTO.eventLanguage || " ");
    eventDTO.description = descriptionFirstPart + handleDescriptionDate(allEventsDays, time) + " (" + eventDTO.timezone + ")";

    let allEvents = allEventsDays.map((eDate, i) => {
        let event: EventDTO = { ...eventDTO };
        if (i !== 0) {
            event.agenda = "";
            event.extraInfo = "";
        }

        allEventsTime.map((eTime, index) => {
            console.log(eDate);
            if (i === index) {
                event.newDate = new Date(eDate + " " + eTime + "Z");
            }
        });
        console.log(event);
        return event;
    });

    return new EventCLusterDTO(clusterId || 0, allEvents);;
}

function handleDescriptionText(type: string, language: string): string {
    let trainingType = type.charAt(0) + type.slice(1).toLowerCase().replace('_', ' ');
    let description = (type === "ASSOCIATE" || type === "PROFESSIONAL") ? trainingType + " Certification Bootcamp" : trainingType;
    // let description = (type === "MONTHLY_RELEASE_UPDATE") ? "Monthly release update" : trainingType + " Certification Bootcamp";
    description += (language === "ENGLISH") ? " | " : " in " + language + " | ";
    return description;
}

function handleDescriptionDate(allEventsDays: Array<string | undefined>, time: string): string {
    let finalString = "";
    for (let event of allEventsDays) {
        if (allEventsDays.slice(-1)[0] === event) {
            finalString += format(new Date(event + " " + time), "do MMMM yyyy h:mm a");
            return finalString;
        }
        finalString += (event != undefined) ? format(new Date(event), "do") + ", " : "";
    }
    return finalString;

}



